export default __webpack_public_path__ + "static/media/dole-lemonade-products-master-desktop.6614b671.png";